import { ButtonHTMLAttributes, FC } from 'react'

import { cn } from '@/app/utils'

type Props = ButtonHTMLAttributes<HTMLButtonElement>

const PaginationButtonNav: FC<Props> = ({
  className,
  disabled,
  children,
  ...props
}) => {
  return (
    <button
      type="button"
      className={cn(
        'rounded-100 bg-white px-14 py-8 text-[#344054] transition-all hover:bg-grey-100/5 active:bg-grey-100/10 disabled:hover:bg-white disabled:active:bg-white xs:px-8',
        disabled && 'cursor-not-allowed opacity-50',
        className
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}

export default PaginationButtonNav
